import { message } from 'antd';

const ProMessage = message;

export default ProMessage;
